// extracted by mini-css-extract-plugin
export default {"root":"A0jvwp","form":"rmuJ0y","input":"W6q_8O","icon":"uZxc3e","iconThemeGreen":"zkwY9c","submit":"LlOWiM"};